import { Component, OnInit , AfterViewInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { ApiService} from "../api.service";

@Component({
  selector: 'app-post-ability-test-tip',
  templateUrl: './post-ability-test-tip.component.html',
  styleUrls: ['./post-ability-test-tip.component.css',]
})
export class PostAbilityTestTipComponent implements OnInit , AfterViewInit {

    level: number;
    learningPathId:number;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private apiService: ApiService) { }

  ngOnInit() {
      this.route.params.subscribe(params => {
          this.level = params['level'];
          this.learningPathId = params['learningPathId'];
      });
  }

  ngAfterViewInit(){
      var html=document.documentElement;
      var htmlFontSize=html.clientWidth/7.5;
      html.style.fontSize=htmlFontSize+"px";
      html.style.backgroundColor="#3d3d6e";
  }

    close() {
      if(this.learningPathId==0){
          let link = ['learning-map'];
          this.router.navigate(link);
      }else{
          this.apiService.ajax({
              'type': 'get',
              'url':'/ddilearner/v1/getLearningPathMetaId/'+this.learningPathId
          }).subscribe(result=>{
              let link = ['learning-path',result.data];
              this.router.navigate(link);
          });
      }
    }

}



// WEBPACK FOOTER //
// ./src/app/post-ability-test-tip/post-ability-test-tip.component.ts